import { scrollToAnchor } from '../utils/scrollToAnchor';
import { EXTERNAL_LINKS, FOOTER_TEXT } from '../constants/content';

const Contact = () => (
  <footer id="contact" className="contact-section">
    <p className="eyebrow">05 / Contact</p>
    <h2>Let's connect</h2>
    <p>For a conversation about software, an opportunity, or a shared interest.</p>
    <div className="contact-links" aria-label="Contact links">
      <a href={EXTERNAL_LINKS.linkedin} target="_blank" rel="noreferrer">LinkedIn <span aria-hidden="true">↗</span><span className="sr-only"> (opens in a new tab)</span></a>
      <a href={EXTERNAL_LINKS.github} target="_blank" rel="noreferrer">GitHub <span aria-hidden="true">↗</span><span className="sr-only"> (opens in a new tab)</span></a>
    </div>
    <div className="footer-bottom"><small>{FOOTER_TEXT}</small><a href="#top" onClick={scrollToAnchor}>Back to top ↑</a></div>
  </footer>
);

export default Contact;